import React, { useState, useEffect } from "react";
import "./ProjectToolbar.css";

const ProjectToolbar = ({
  viewMode,
  onViewModeChange,
  onSearch,
  onStatusChange,
  statusFilter = "Tất cả hợp đồng",
  initialSearchTerm = "",
  onAddContract,
}) => {
  const [searchInput, setSearchInput] = useState(initialSearchTerm);

  // Cập nhật searchInput khi initialSearchTerm thay đổi
  useEffect(() => {
    setSearchInput(initialSearchTerm);
  }, [initialSearchTerm]);

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    onSearch(searchInput);
  };

  return (
    <div className="project-toolbar">
      <div className="toolbar-left">
        <div className="search-box">
          {" "}
          <form onSubmit={handleSearchSubmit}>
            <input
              type="text"
              placeholder="Tìm kiếm hợp đồng..."
              value={searchInput}
              onChange={handleSearchChange}
            />
            <button type="submit">
              <span className="material-icons">search</span>
            </button>
          </form>
        </div>{" "}
        <div className="filter-box">
          <select
            className="filter-button"
            onChange={(e) => {

              onStatusChange(e.target.value);
            }}
            value={statusFilter}
          >
            <option value="Tất cả hợp đồng">Tất cả hợp đồng</option>
            <option value="Chưa bắt đầu">Chưa bắt đầu</option>
            <option value="Đang thực hiện">Đang thực hiện</option>
            <option value="Hoàn thành">Hoàn thành</option>
            <option value="Tạm dừng">Tạm dừng</option>
            <option value="Hủy bỏ">Hủy bỏ</option>
          </select>
        </div>
      </div>{" "}
      <div className="toolbar-right">
        <button className="add-project-btn" onClick={onAddContract}>
          <span className="material-icons">add</span>
          Thêm hợp đồng
        </button>
        <div className="view-toggle">
          <button
            className={`toggle-btn ${viewMode === "grid" ? "active" : ""}`}
            onClick={() => onViewModeChange("grid")}
          >
            <span className="material-icons">grid_view</span>
          </button>
          <button
            className={`toggle-btn ${viewMode === "list" ? "active" : ""}`}
            onClick={() => onViewModeChange("list")}
          >
            <span className="material-icons">view_list</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectToolbar;
